/* eslint-disable @repo/internal/react/require-jsdoc */

import React, { type ReactNode, useContext } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { BrandHeading } from '../../brand-heading';
import HeadingContext from '../../heading-context';
import { sentenceToKebab } from '../../utils/sentence-to-kebab';

const levelMap = {
	h2: 'large',
	h3: 'medium',
	h4: 'small',
	h5: 'xsmall',
	h6: 'xsmall',
} as const;

const depthMap = {
	h2: 2,
	h3: 3,
	h4: 4,
	h5: 5,
	h6: 6,
};

const headingStylesH2 = xcss({
	marginBlockStart: 'space.400',
	marginBlockEnd: 'space.200',
});

const headingStylesH3 = xcss({
	marginBlockStart: 'space.200',
	marginBlockEnd: 'space.100',
});

const headingStylesH4 = xcss({
	marginBlockStart: 'space.100',
	marginBlockEnd: 'space.100',
});

const styleMap = {
	h2: headingStylesH2,
	h3: headingStylesH3,
	h4: headingStylesH4,
	h5: headingStylesH4,
	h6: headingStylesH4,
};

export const Heading = ({
	children,
	level,
}: {
	children: ReactNode;
	level: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}) => {
	const { addHeading } = useContext(HeadingContext);
	const value = children?.toString() || '';
	const id = sentenceToKebab(value);
	const depth = depthMap[level];
	if (depth <= 3) {
		addHeading({
			id,
			depth,
			value,
		});
	}

	return (
		<div
			// `id` to give the `LocalNav` an anchor to link to
			id={id}
		>
			<Box xcss={styleMap[level]}>
				<BrandHeading size={levelMap[level]} as={level}>
					{children}
				</BrandHeading>
			</Box>
		</div>
	);
};
